import React, { useState, useEffect } from 'react';
import { Card, Chip } from '@mui/material';
import { ColDef } from 'ag-grid-community';
import AgGridTable from '../../components/table/AgGridTable';
import {  Tooltip } from "@mui/material";

import { ICellRendererParams } from "ag-grid-community";

import axiosInstance from '../../axios/axios';

const AgentLayout = () => {
  const [rowData, setRowData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Active":
        return {
          color: "#00a61b",
          dotColor: "#00a61b",
          background: "rgba(0, 166, 27, .1)",
        };
      case "Inactive":
        return {
          color: "#f53b3b",
          dotColor: "#f53b3b",
          background: "rgba(245, 59, 59, .1)",
        };
      default:
        return {
          color: "#696595",
          dotColor: "#696595",
          background: "rgba(105, 101, 149, .1)",
        };
    }
  };

  // Column definitions for the AG Grid
  const columnDefs: ColDef[] = [
    {
      field: 'name',
      headerName: 'Agent Name',
      filter: true,
      minWidth: 150,
      flex: 1,
              cellRenderer:(params: ICellRendererParams) => {
                if (!params.value) return null;
                return (
                  <Tooltip
                    title={params.value}
                    arrow
                    placement="bottom"
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #ddd",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          fontSize: "14px",
                        },
                      },
                      arrow: { sx: { color: "#fff" } },
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                      }}
                    >
                      {params.value}
                    </span>
                  </Tooltip>
                );}

    },
    {
      field: 'description',
      headerName: 'Description',
      filter: true,
      minWidth: 150,
      cellRenderer:(params: ICellRendererParams) => {
                if (!params.value) return null;
                return (
                  <Tooltip
                    title={params.value}
                    arrow
                    placement="bottom"
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #ddd",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          fontSize: "14px",
                        },
                      },
                      arrow: { sx: { color: "#fff" } },
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                      }}
                    >
                      {params.value}
                    </span>
                  </Tooltip>
                );}
    },

    {
      field: 'status_display',
      headerName: 'Status',
      filter: true,
      minWidth: 200,
      cellRenderer: (params: any) => {
        if (!params.value) return null;
        const { color, dotColor, background } = getStatusColor(params.value);

        return (
          <Chip
            label={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: dotColor,
                  }}
                />
                {params.value}
              </span>
            }
            size="small"
            variant="outlined"
            sx={{
              fontWeight: "bold",
              color: color,
              maxWidth: "fit-content",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              mt: 1,
              backgroundColor: background,
            }}
          />
        );
      },
    },
    {
      field: 'last_modified',
      headerName: 'Last Active',
      filter: true,
      minWidth: 250,
      sort: 'desc',
      sortIndex: 0,
      cellRenderer:(params: ICellRendererParams) => {
                if (!params.value) return null;
                return (
                  <Tooltip
                    title={params.value}
                    arrow
                    placement="bottom"
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#fff",
                          color: "#000",
                          border: "1px solid #ddd",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          fontSize: "14px",
                        },
                      },
                      arrow: { sx: { color: "#fff" } },
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                      }}
                    >
                      {params.value}
                    </span>
                  </Tooltip>
                );}
    },

  ];

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // Replace with your actual API endpoint
        const response = await axiosInstance.get('/securityscan/agent');
        if (response.data?.data) {
          setRowData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching Cloud data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <AgGridTable
      columnDefs={columnDefs}
      data={rowData}
      showSearch
      isRowSelectable
      height={'calc(100vh - 78px)'}
      isLoading={isLoading}
    />
  );
};

export default AgentLayout;